export const PERSONAL_DATA_CONSENT_TEXT =
	'Я даю согласие на обработку моих персональных данных в соответствии с Федеральным законом от 27.07.2006 г. № 152-ФЗ "О персональных данных" для целей рассмотрения моей кандидатуры на указанную вакансию';

export const PERSONAL_DATA_CONSENT_AGREEMENT_URL = 'https://relevanter.ru/persdan';

export const PERSONAL_DATA_POLICY_URL = 'https://relevanter.ru/pdn';
